/**
 * Pipe que trata a resposta de expediente, trata os identificadores para
 * montagem do html com títulos e ítens normais e títulos e itens de grupo.
 */

import { PipeTransform, Pipe } from '@angular/core';


@Pipe({
  name: 'formatExpediente'
})
export class FormatExpedientePipe implements PipeTransform {
  currentGroup: { title: string, content: string } | null = null;
  html = '';
  renderizouBotao = true;

  transform(value: string): string {
    if (!value) {
      return '';
    }

    const lines = value.split('\n').filter(line => line.trim() !== '');

    for (const line of lines) {
      const trimmedLine = line.trim();
      // Identifica um grupo colapsável (começa com "** Grupo")
      if (trimmedLine.startsWith('** Grupo')) {

        if (this.renderizouBotao) {
          this.html += `
          <br />
          <button
            id="toggle-btn"
            class="br-button primary dark-mode mr-3"
            type="button"
          >
              Expandir todos
          </button>`;
          this.renderizouBotao = false;
        }

        // Fecha o grupo anterior se existir
        if (this.currentGroup) {
          this.html += this.renderGroup(this.currentGroup);
          this.currentGroup = null;
        }

        const groupTitle = trimmedLine.substring(3).trim(); // Remove "** "
        this.currentGroup = {
          title: groupTitle,
          content: ''
        };
      }
      // Identifica um subtítulo dentro do grupo (começa com "##").
      else if (trimmedLine.startsWith('## ')) {
        const subtitle = trimmedLine.substring(3).trim();
        if (this.currentGroup) {
          // this.currentGroup.content += `< p > <strong>${ subtitle } </strong></ >\n`;
          this.currentGroup.content += `</p><p><strong>${subtitle}</strong> <br>\n`;
        } else {
          this.html += `<p><strong>${subtitle}</strong></p>\n`;
        }
      }
      // Linha normal de conteúdo.
      else {
        // Trata linhas de Grupo.
        if (this.currentGroup) {
          // Se for uma linha de coordenação (contém "Coordenação") OK.
          if (trimmedLine.includes('Coordenação')) {
            this.currentGroup.content += `<p><strong>${trimmedLine}</strong><br>`;
          }
          // Se for uma linha de membros ou especialistas e contiver ## OK.
          else if (trimmedLine.includes('Membros') || trimmedLine.includes('Especialistas')) {
            this.currentGroup.content += `<p><strong>${trimmedLine}</strong></p><br>`;
          }
          else {
            this.currentGroup.content += `${trimmedLine}<br>\n`;
          }
        } else {
          // Trata títulos normais (começa com "**")
          if (trimmedLine.startsWith('** ')) {
            this.html += `<h4>${trimmedLine.substring(3).trim()}</h4>\n`;
          } else {
            // Conteúdo normal fora de grupo.
            if (this.html.endsWith('</p>\n')) {
              this.html = this.html.slice(0, -5) + '<br>' + trimmedLine + '</p>\n';
            } else {
              this.html += `<p>${trimmedLine}</p>\n`;
            }
          }
        }
      }
    }

    // Fecha o último grupo se ainda estiver aberto.
    if (this.currentGroup) {
      this.html += this.renderGroup(this.currentGroup);
    }

    return this.html;
  }

  /**
   * Trata o grupo e seu conteúdo.
   * @param group entradada para grupo e seu conteúdo.
   * @returns grupo tratado.
   */
  private renderGroup(group: { title: string, content: string }): string {
    const groupId = this.toCamelCase(group.title);
    return `
          <h4>
            <a
              class="toggle-collapsed"
              data-toggle="collapse"
              href="#${groupId}"
              aria-expanded="false"
              aria-controls="${groupId}">
              <i class="fas fa-chevron-down fa-lg"></i>
              <i class="fas fa-chevron-up fa-lg"></i>
            </a>
            ${group.title}
          </h4>
          <div class="collapse" id="${groupId}">
            ${group.content}
          </div>`;
  }

  /**
   *
   * @param str string de entrada.
   * @returns título em camel case.
   */
  private toCamelCase(str: string): string {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
        index === 0 ? match.toLowerCase() : match.toUpperCase()
      )
      .replace(/[^\w]/g, '');
  }
}
